module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/4a03076e2ebc9f2807e00c6f85fd0c17.png";